import styled, { css } from 'styled-components';
import { IListControlStyledProps } from './list-control.types';

export const ListControlStyled = styled.div<IListControlStyledProps>`
  border: 1px solid ${({ theme }) => theme.colors.gray[10]};
  background-color: ${({ theme }) => theme.colors.gray[0]};

  ${({ $isChecked }) => $isChecked && css`
    border: 1px solid ${({ theme }) => theme.colors.blue[20]};
    background-color: ${({ theme }) => theme.colors.gray[3]};
  `}

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.gray[10]};
    background-color: ${({ theme }) => theme.colors.gray[3]};
  }

  cursor: pointer;
  border-radius: 12px;
  height: 40px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 10px;
  gap: 8px;
`;
